import React from 'react';
import PropTypes from 'prop-types';
import AbtraPlayerVideoPortal from './AbtraPlayerVideoPortal';


function AbtraPlayerVideosRender({ abtraVideosData }) {
    return (
        <>
            {
                abtraVideosData.map((videoData) => {
                    return (
                        <AbtraPlayerVideoPortal
                            key={videoData.videoUrl}
                            videoUrl={videoData.videoUrl}
                            thumbnailImageLink={videoData.thumbnailImageLink}
                            container={videoData.container}
                        />
                    );
                })
            }
        </>
    );
}

AbtraPlayerVideosRender.propTypes = {
    abtraVideosData: PropTypes.array,
};

export default AbtraPlayerVideosRender;